// Time scale of a stored duration value (e.g. the Care Forecast's
// { value: 3, scale: 'month' }). Values are stable slug keys stored in
// documents; new scales (week, year, ...) are added when a product feature
// needs them.
export enum DurationScale {
  month = 'month',
}
